import Api from './Api';

class LogicBaseAppLikeApi extends Api {
  url = 'logicbaseapplikes';
}

const singleton = new LogicBaseAppLikeApi();
export default singleton;
